import { z } from "zod"

export const paymentOptionSchema = z.enum([
  "card",
  "credits",
  "combined",
  "postPayment",
  "fbaPayment",
  "prePayment",
  "bulkPrePayment",
  "bulkPostPayment",
])

export const addressSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  phone: z.string().optional(),
  company: z.string().optional(),
  address1: z.string(),
  address2: z.string().optional(),
  city: z.string(),
  state: z.string().optional(),
  zip: z.string(),
  country: z.string(),
})

export const orderFormStateSchema = z.object({
  type: z.enum(["sample", "manual", "fba", "bulk"]),
  status: z.enum(["init", "products", "address", "payment", "cardPayment"]),
  products: z.array(
    z.object({
      id: z.string(),
      quantity: z.number(),
    }),
  ),
  countryCode: z.string().optional(),
  shippingAddress: addressSchema.partial().optional(),
  paymentOption: paymentOptionSchema.optional(),
  creditsAmount: z.number().optional(),
})

export type OrderFormState = z.infer<typeof orderFormStateSchema>

export type Address = z.infer<typeof addressSchema>

export type PaymentOption = z.infer<typeof paymentOptionSchema>

export type ProductValidateError =
  | "COUNTRY_NOT_AVAILABLE"
  | "DISCONTINUED"
  | "NOT_FOUND"
  | "NOT_FBA"
  | "FBA_ONLY_ONE_PRODUCT_ALLOWED"
  | "OUT_OF_STOCK"
  | "SOON_TO_BE_DISCONTINUED"
  | "BULK_ONLY_ONE_PRODUCT_ALLOWED"
  | "BULK_MIN_QUANTITY_REQUIRED"
